<!-- 设备列表页面 -->
<template>
  <div class="vcnDeviceList vcnDevicelist_warpd">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <el-scrollbar style="height: 100%">
          <el-tree
            :data="frame"
            :props="treeProps"
            class="shebeiDiv"
            @node-click="currentChange"
            :expand-on-click-node="true"
            :default-expand-all="false"
            :default-expanded-keys="['200000024']"
            :highlight-current="true"
            node-key="deviceID"
            ref="refTree"
          >
            <template slot-scope="{ node }">
              <element-tree-line
                :node="node"
                :showLabelLine="true"
                :indent="16"
                class="tree-line"
              >
                <span class="custom-tree-node" style="display: block">
                  <span style="margin-left: 3px">{{ node.label }}</span>
                </span>
              </element-tree-line>
            </template></el-tree
          >
        </el-scrollbar>
      </div>

      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar flex-row">
          <el-button
            type="primary"
            class="iss-operation-button"
            icon="iconfont icon-iconfontfanhui"
            @click="retBtn"
          >
            返回
          </el-button>
          <el-button
            type="primary"
            v-if="showDevList == 2 || showDevList == 3 || showDevList == 4"
            class="iss-operation-button"
            icon="el-icon-plus"
            @click="handleAdd"
            >新增</el-button
          >
          <el-button
            type="primary"
            v-if="showDevList == 1"
            class="iss-operation-button"
            icon="iconfont icon-daoru"
            @click="synData"
          >
            同步
          </el-button>
          <el-button
            type="primary"
            v-if="showDevList == 2 || showDevList == 3 || showDevList == 4"
            class="iss-operation-button"
            icon="el-icon-delete"
            @click="delDev"
          >
            批量删除
          </el-button>
        </div>
        <div class="section-main_table">
          <ioc-table
            ref="devTab"
            :data="deviceData"
            :option="
              showDevList == 1
                ? deviceOption
                : showDevList == 2
                ? devOption
                : showDevList == 3
                ? devOptionFire
                : devOptionFireSub
            "
            :page="devicePage"
            @search-change="handleSearchChange"
            @search-reset="handleSearchReset"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @refresh-change="refreshChange"
            @selection-change="handleSelectionChange"
          >
            <!-- 定制操作栏按钮 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="列表"
                placement="top"
                popper-class="tooltip-draw"
              >
                <!-- 防区子列表 电梯子列表 -->
                <el-button
                  v-if="scope.row.deviceMark == 38 || scope.row.deviceMark == 43"
                  type="text"
                  @click="goDevList(scope.row)"
                  icon="iconfont icon-task-all"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="列表"
                placement="top"
                popper-class="tooltip-draw"
              >
                <!-- 消防子列表 -->
                <el-button
                  v-if="scope.row.deviceMark == 44"
                  type="text"
                  @click="goDevFireList(scope.row)"
                  icon="iconfont icon-task-all"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="部件列表"
                placement="top"
                popper-class="tooltip-draw"
              >
                <!-- 部件列表 -->
                <el-button
                  v-if="scope.row.deviceMark == 27 && !scope.row.subDeviceMark"
                  type="text"
                  @click="goDevFireChildrenList(scope.row)"
                  icon="iconfont icon-task-all"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('deviceAccess.button.view')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  @click="seeDel(scope.row)"
                  icon="iconfont icon-Detail"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="编辑"
                placement="top"
                popper-class="tooltip-draw"
              >
                <!-- 防区子列表 -->
                <el-button
                  type="text"
                  v-if="
                    scope.row.deviceMark == 2 ||
                    scope.row.deviceMark == 27 ||
                    scope.row.deviceMark == 45
                  "
                  @click="handleUpdate(scope.row)"
                  icon="iconfont icon-xiugai"
                ></el-button>
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('deviceAccess.button.delete')"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  v-if="
                    scope.row.deviceMark == 2 ||
                    scope.row.deviceMark == 27 ||
                    scope.row.deviceMark == 45
                  "
                  type="text"
                  @click="delDevBtn(scope.row)"
                  icon="iconfont icon-shanchu"
                ></el-button>
              </el-tooltip>
            </template>
          </ioc-table>
          <appPanel
            class="app-panel"
            :isExpand="dialogVisible"
            @cancel="dialogVisible = false"
            title="设备详情"
          >
            <el-form :model="devDetail" style="padding: 0 40px" label-suffix=" ：">
              <el-scrollbar>
                <el-row v-if="showDevList == 1">
                  <el-col :span="24">
                    <el-form-item label="设备名称">
                      <span>{{ devDetail.deviceName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备编码">
                      <span>{{ devDetail.thirdDeviceId }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="主设备类型">
                      <span>{{ devDetail.deviceTypeName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属区域">
                      <span>{{ devDetail.areaDevGroupName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备状态">
                      <span>{{ devDetail.status }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备ID">
                      <span>{{ devDetail.deviceID }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="showDevList == 2">
                  <el-col :span="24">
                    <el-form-item label="设备名称">
                      <span>{{ devDetail.deviceName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备编号">
                      <span>{{ devDetail.thirdDeviceId }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="主设备类型">
                      <span>{{ devDetail.deviceTypeName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属区域">
                      <span>{{ devDetail.areaDevGroupName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="备注">
                      <span>{{ devDetail.deviceDescription }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row v-if="showDevList == 3">
                  <el-col :span="24">
                    <el-form-item label="主机名称">
                      <span>{{ devDetail.deviceName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="主机编号">
                      <span>{{ devDetail.mac }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备类型">
                      <span>{{ devDetail.deviceTypeName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备型号">
                      <span>{{ devDetail.deviceVersion }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备厂商">
                      <span>{{ devDetail.factoryName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="唯一标识号">
                      <span>{{ devDetail.thirdDeviceId }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属区域">
                      <span>{{ devDetail.areaDevGroupName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="设备状态">
                      <span>{{ devDetail.status }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="备注">
                      <span>{{ devDetail.thirdDeviceDesc }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="showDevList == 4">
                  <el-col :span="12">
                    <el-form-item label="主机系统类型">
                      <span>{{ devDetail.deviceMarkName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="主机编号">
                      <span>{{ devDetail.mac }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="部件名称">
                      <span>{{ devDetail.thirdDeviceName }}</span>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="部件类型">
                      <span>{{ devDetail.subDeviceMarkName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="部件地址">
                      <span>{{ devDetail.mac }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="部件说明">
                      <span>{{ devDetail.thirdDeviceDesc }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-scrollbar>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
            </span>
          </appPanel>

          <!-- 新增，编辑 -->
          <appPanel
            class="app-panel"
            :isExpand="showIot"
            @cancel="handleCancel"
            title="设备信息"
          >
            <el-form
              label-width="110px"
              :model="iotFrom"
              :rules="iotRules"
              ref="refIotFrom"
            >
              <el-col :span="24" v-if="showDevList == 2">
                <el-form-item label="设备名称" prop="thirdDeviceName">
                  <el-input v-model="iotFrom.thirdDeviceName"></el-input>
                </el-form-item>
                <el-form-item label="设备编号" prop="thirdDeviceId">
                  <el-input v-model="iotFrom.thirdDeviceId"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="thirdDeviceDesc">
                  <el-input
                    type="textarea"
                    v-model="iotFrom.thirdDeviceDesc"
                    maxlength="200"
                    :autosize="{ minRows: 5 }"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24" v-if="showDevList == 3">
                <el-form-item label="主机名称" prop="deviceName">
                  <el-input
                    v-model="iotFrom.deviceName"
                    placeholder="请输入主机名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="主机编号" prop="thirdDeviceId">
                  <el-input
                    v-if="!iotFrom.deviceID"
                    v-model="iotFrom.thirdDeviceId"
                    placeholder="请输入主机编号"
                  ></el-input>
                  <span v-else>
                    {{ iotFrom.mac }}
                  </span>
                </el-form-item>
                <el-form-item label="设备厂商" prop="factoryId">
                  <el-select
                    v-model="iotFrom.factoryId"
                    placeholder="请选择设备厂商"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in factoryIdList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="消防型号" prop="deviceVersion">
                  <el-select
                    v-model="iotFrom.deviceVersion"
                    placeholder="请选择消防型号"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in deviceVersionList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="设备状态" prop="status">
                  <el-select
                    v-model="iotFrom.status"
                    placeholder="请选择设备状态"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="thirdDeviceDesc">
                  <el-input
                    type="textarea"
                    v-model="iotFrom.thirdDeviceDesc"
                    maxlength="200"
                    :autosize="{ minRows: 5 }"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24" v-if="showDevList == 4">
                <el-form-item label="部件名称" prop="thirdDeviceName">
                  <el-input
                    v-model="iotFrom.thirdDeviceName"
                    placeholder="请输入部件名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="部件地址" prop="mac">
                  <el-input v-model="iotFrom.mac" placeholder="请输入部件地址"></el-input>
                </el-form-item>
                <el-form-item label="部件类型" prop="subDeviceMark">
                  <el-select
                    v-model="iotFrom.subDeviceMark"
                    placeholder="请选择部件类型"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in subDeviceMarkList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="部件回路" prop="loop">
                  <el-input
                    v-model="iotFrom.loop"
                    placeholder="请输入部件回路"
                  ></el-input>
                </el-form-item> -->
                <el-form-item label="部件说明" prop="thirdDeviceDesc">
                  <el-input
                    type="textarea"
                    v-model="iotFrom.thirdDeviceDesc"
                    maxlength="200"
                    :autosize="{ minRows: 5 }"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="info" @click="handleCancel"> 取消 </el-button>
              <el-button type="primary" @click="handleSubmit" v-if="showDevList == 2">
                确定
              </el-button>
              <el-button
                type="primary"
                @click="handleSubmitFire"
                v-else-if="showDevList == 3"
              >
                确定
              </el-button>
              <el-button type="primary" @click="handleSubmitFireSub" v-else>
                确定
              </el-button>
            </span>
          </appPanel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../../api/index";
import { Dic } from "$utils";
import utils from "@src/common/utils";
import ElementTreeLine from "element-tree-line";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  components: {
    appPanel,
    ElementTreeLine,
  },
  data() {
    return {
      factoryIdList: [],
      deviceMarkList: [],
      statusList: [
        {
          label: "在线",
          value: "1",
        },
        {
          label: "离线",
          value: "0",
        },
      ],
      deviceVersionList: Dic.find("SENU095"),
      subDeviceMarkList: Dic.find("SENU094"),
      searchParams: {},
      showDevList: "1", //1 主设备，2 防区，电梯，3，消防
      showIot: false,
      checkIotForm: {},
      iotRules: {
        thirdDeviceId: [
          {
            required: true,
            message: "请输入设备编号",
            trigger: ["blur", "change"],
          },
        ],
        thirdDeviceName: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: ["blur", "change"],
          },
        ],
        deviceName: [
          {
            required: true,
            message: "请输入主机名称",
            trigger: ["blur", "change"],
          },
        ],
        thirdDeviceId: [
          {
            required: true,
            message: "请输入主机编号",
            trigger: ["blur", "change"],
          },
        ],
        factoryId: [
          {
            required: true,
            message: "请选择设备厂商",
            trigger: ["blur", "change"],
          },
        ],
        deviceVersion: [
          {
            required: true,
            message: "请选择消防型号",
            trigger: ["blur", "change"],
          },
        ],
        status: [
          {
            required: true,
            message: "请选择设备状态",
            trigger: ["blur", "change"],
          },
        ],
        mac: [
          {
            required: true,
            message: "请输入部件地址",
            trigger: ["blur", "change"],
          },
        ],
        // loop: [
        //   {
        //     required: true,
        //     message: "请输入部件回路",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        subDeviceMark: [
          {
            required: true,
            message: "请选择部件类型",
            trigger: ["blur", "change"],
          },
        ],
      },
      iotFrom: {
        thirdDeviceId: "",
        thirdDeviceName: "",
        thirdDeviceDesc: "",
        deviceID: "",

        deviceName: "",
        deviceMark: "",
        factoryId: "",
        deviceVersion: "",
        status: "",

        mac: "",
        // loop: "",
        subDeviceMark: "",
      },
      showSearch: false,
      delDevSin: {},
      delConfirm: false,
      // 设备详情数据
      devDetail: {},
      // 详情弹框
      dialogVisible: false,
      // 选中设备ID集合
      selDev: [],

      // 系统id
      systemId: "",
      platID: "",
      factoryId: "",
      systemName: "",
      deviceType: "",
      // 树的props
      treeProps: {
        label: "thirdDeviceName",
        children: "subDeviceList",
      },
      // 设备树的数据
      frame: [],
      // 树的节点值
      treeKey: "200000024",
      // 分页属性设置
      devicePage: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      deviceData: [],
      devOption: {
        emptyText: this.$t("deviceAccess.message.nodata"),
        stripe: true,
        maxHeight: "100%",
        page: true,
        align: "center",
        menuAlign: "center",
        header: false,
        selection: true,
        delBtn: false,
        editBtn: false,
        column: [
          {
            label: "设备名称",
            prop: "deviceName",
            overHidden: true,
            search: true,
          },
          {
            label: "设备编号",
            prop: "thirdDeviceId",
            overHidden: true,
          },
          {
            label: this.$t("deviceAccess.label.area"),
            prop: "areaDevGroupName",
            overHidden: true,
          },
          {
            label: this.$t("deviceAccess.label.deviceid"),
            prop: "deviceID",
            overHidden: true,
          },
        ],
      },
      devOptionFire: {
        emptyText: this.$t("deviceAccess.message.nodata"),
        stripe: true,
        maxHeight: "100%",
        page: true,
        align: "center",
        menuAlign: "center",
        header: false,
        selection: true,
        delBtn: false,
        editBtn: false,
        column: [
          {
            label: "主机名称",
            prop: "deviceName",
            overHidden: true,
            search: true,
          },
          {
            label: "主机编号",
            prop: "mac",
            overHidden: true,
          },
          {
            label: "设备类型",
            prop: "deviceMark",
            overHidden: true,
            formatter: function (row, value) {
              return value ? Dic.findByValue("SENU087", value) : "";
            },
          },
          {
            label: "消防型号",
            prop: "deviceVersion",
            overHidden: true,
            formatter: function (row, value) {
              return value ? Dic.findByValue("SENU095", value) : "";
            },
          },
          {
            label: this.$t("deviceAccess.label.status"),
            prop: "status",
            overHidden: true,
            formatter: function (row, value) {
              return Dic.findByValue("SENU015", value);
            },
          },
        ],
      },
      devOptionFireSub: {
        emptyText: this.$t("deviceAccess.message.nodata"),
        stripe: true,
        maxHeight: "100%",
        page: true,
        align: "center",
        menuAlign: "center",
        header: false,
        selection: true,
        delBtn: false,
        editBtn: false,
        column: [
          {
            label: "主机系统类型",
            prop: "deviceMark",
            overHidden: true,
            formatter: function (row, value) {
              return value ? Dic.findByValue("SENU087", value) : "";
            },
          },
          {
            label: "主机编号",
            prop: "parentMac",
            overHidden: true,
          },
          {
            label: "部件名称",
            prop: "thirdDeviceName",
            overHidden: true,
            search: true,
          },
          {
            label: "部件类型",
            prop: "subDeviceMark",
            overHidden: true,
            formatter: function (row, value) {
              return value ? Dic.findByValue("SENU094", Number(value)) : "";
            },
          },
          {
            label: "部件地址",
            prop: "mac",
            search: true
          },
          // {
          //   label: "回路",
          //   prop: "loop",
          // },
        ],
      },
      deviceOption: {
        emptyText: this.$t("deviceAccess.message.nodata"),
        stripe: true,
        maxHeight: "100%",
        page: true,
        align: "center",
        menuAlign: "center",
        header: false,
        selection: false,
        delBtn: false,
        editBtn: false,
        column: [
          {
            label: this.$t("deviceAccess.label.cameraname"),
            prop: "deviceName",
            overHidden: true,
            search: true,
          },
          {
            label: this.$t("deviceAccess.label.maintype"),
            prop: "deviceType",
            overHidden: true,
            formatter: function (row, value) {
              if (row.deviceTypeName) {
                return row.deviceTypeName;
              } else {
                return Dic.findByValue("SENU086", value);
              }
            },
          },
          {
            label: this.$t("deviceAccess.label.area"),
            prop: "areaDevGroupName",
            overHidden: true,
          },
          {
            label: this.$t("deviceAccess.label.status"),
            prop: "status",
            overHidden: true,
            formatter: function (row, value) {
              return Dic.findByValue("SENU015", value);
            },
          },
          {
            label: this.$t("deviceAccess.label.deviceid"),
            prop: "deviceID",
            overHidden: true,
          },
        ],
      },
    };
  },
  created() {
    this.systemId = this.$route.query.systemId;
    this.systemName = this.$route.query.systemName;
    this.platID = this.$route.query.platID;
    this.factoryId = this.$route.query.factoryId;
    this.deviceType = this.$route.query.deviceType;
  },
  mounted() {
    // 请求树根节点
    this.getAccessDeviceInfoTree();
    // 请求设备列表
    this.getDevList();
  },
  methods: {
    queryFactoryList() {
      this.$fetch(api.device.queryFireDeviceFactoryList).then((res) => {
        if (res.success) {
          this.factoryIdList = res.returnObj.map((item) => {
            return {
              label: item.factoryName,
              value: Number(item.factoryId),
            };
          });
        }
      });
    },
    handleSelectionChange(selections) {
      let myAry = [];
      selections.map((item) => {
        myAry.push(item.deviceID);
      });
      this.selDev = myAry;
    },
    handleSearchReset() {
      this.searchParams = {};
      this.getDevList();
    },
    handleSearchChange(param) {
      console.log(param);
      this.devicePage.pageNum = 1;
      this.searchParams = Object.assign({}, param);
      this.getDevList();
    },
    refreshChange() {
      this.getDevList();
    },
    handleCurrentChange(val) {
      this.devicePage.pageNum = val;
      this.getDevList();
    },
    handleSizeChange(val) {
      this.devicePage.pageNum = 1;
      this.devicePage.pageSize = val;
      this.getDevList();
    },

    // 子列表 防区
    goDevList(item) {
      console.log(item);
      this.deviceData = [];
      this.checkIotForm = Object.assign({}, item);
      this.devicePage.pageNum = 1;
      this.devicePage.pageSize = 10;
      this.showDevList = 2;
      this.$refs.devTab.reset();
    },
    // 子列表 消防主机设备
    goDevFireList(item) {
      console.log(item);
      this.deviceData = [];
      this.checkIotForm = Object.assign({}, item);
      this.devicePage.pageNum = 1;
      this.devicePage.pageSize = 10;
      this.showDevList = 3;
      this.$refs.devTab.reset();
      this.queryFactoryList();
    },
    //子列表 部件
    goDevFireChildrenList(item) {
      console.log(item);
      this.deviceData = [];
      this.showDevList = 4;
      this.checkIotForm = Object.assign({}, item);
      this.devicePage.pageNum = 1;
      this.devicePage.pageSize = 10;
      this.$refs.devTab.reset();
    },
    handleSubmitFireSub() {
      this.$refs.refIotFrom.validate((res) => {
        if (res) {
          let params = {
            thirdDeviceId: this.checkIotForm.thirdDeviceId,
            // parentDeviceId: this.checkIotForm.deviceID,
            factoryId: this.checkIotForm.factoryId,
            systemId: this.systemId,
            deviceID: this.iotFrom.deviceID,
            subDeviceMark: this.iotFrom.subDeviceMark,
            mac: this.iotFrom.mac,
            // loop: this.iotFrom.loop,
            thirdDeviceName: this.iotFrom.thirdDeviceName,
            thirdDeviceDesc: this.iotFrom.thirdDeviceDesc,
          };
          console.log(params);

          let url = api.device.addFireSubDevice;
          if (params.deviceID) {
            url = api.device.updateFireSubDevice;
          }
          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
              this.handleCancel();
              this.getDevList();
            } else {
              this.$message.error("操作失败");
            }
          });
        }
      });
    },
    handleSubmitFire() {
      this.$refs.refIotFrom.validate((res) => {
        if (res) {
          let params = {
            parentDeviceId: this.checkIotForm.deviceID,
            parentDeviceIds:
              this.checkIotForm.parentDeviceIds + "," + this.checkIotForm.deviceID,
            systemId: this.systemId,
            thirdDeviceName: this.iotFrom.deviceName,
            deviceMark: "27",
            deviceID: this.iotFrom.deviceID,
            factoryId: this.iotFrom.factoryId,
            status: this.iotFrom.status,
            thirdDeviceId: this.iotFrom.thirdDeviceId,
            thirdDeviceName: this.iotFrom.deviceName,
            thirdDeviceDesc: this.iotFrom.thirdDeviceDesc,
            deviceVersion: this.iotFrom.deviceVersion,
          };
          console.log(params);

          let url = api.device.addFireDevice;
          if (params.deviceID) {
            url = api.device.updateFireDevice;
          }
          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
              this.handleCancel();
              this.getDevList();
            } else {
              this.$message.error("操作失败");
            }
          });
        }
      });
    },
    handleSubmit() {
      console.log(this.checkIotForm);
      this.$refs.refIotFrom.validate((res) => {
        if (res) {
          let params = {
            deviceType: this.checkIotForm.deviceType,
            deviceMark: this.checkIotForm.deviceType == 28 ? "45" : "2",
            parentDeviceId: this.checkIotForm.deviceID,
            parentDeviceIds:
              this.checkIotForm.parentDeviceIds + "," + this.checkIotForm.deviceID,
            systemId: this.systemId,
            thirdDeviceDesc: this.iotFrom.thirdDeviceDesc,
            thirdDeviceId: this.iotFrom.thirdDeviceId,
            thirdDeviceName: this.iotFrom.thirdDeviceName,
            deviceID: this.iotFrom.deviceID,
          };
          console.log(params);
          let url = api.gasTruck.addDevice;
          if (params.deviceID) {
            url = api.gasTruck.updateDevice;
          }
          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
              this.handleCancel();
              this.getDevList();
            } else {
              this.$message.error("操作失败");
            }
          });
        }
      });
    },
    handleCancel() {
      this.$refs.refIotFrom.resetFields();
      for (let key in this.iotFrom) {
        this.iotFrom[key] = "";
      }
      this.showIot = false;
    },
    handleAdd() {
      this.showIot = true;
    },
    handleUpdate(item) {
      console.log(item);
      this.showIot = true;
      if (this.showDevList == 2) {
        this.iotFrom.thirdDeviceDesc = item.thirdDeviceDesc;
        this.iotFrom.thirdDeviceId = item.thirdDeviceId;
        this.iotFrom.thirdDeviceName = item.deviceName;
        this.iotFrom.deviceID = item.deviceID;
      } else if (this.showDevList == 3 || this.showDevList == 4) {
        for (let key in this.iotFrom) {
          this.iotFrom[key] = item[key];
        }
        this.iotFrom.deviceVersion = Number(this.iotFrom.deviceVersion);
        this.iotFrom.subDeviceMark = Number(this.iotFrom.subDeviceMark);
      } else {
        //
      }
    },
    // 返回按钮
    retBtn() {
      console.log(this.showDevList);
      if (this.showDevList == 1) {
        this.$router.push("/deviceaccess/index");
      } else if (this.showDevList == 2 || this.showDevList == 3) {
        this.showDevList = 1;
        this.devicePage.pageNum = 1;
        this.devicePage.pageSize = 10;
        this.$refs.devTab.reset();
      } else {
        this.showDevList = 3;
        this.devicePage.pageNum = 1;
        this.devicePage.pageSize = 10;
        this.$refs.devTab.reset();
      }
    },
    // 同步数据
    synData() {
      const params = {
        systemId: this.systemId,
        platId: this.platID,
        factoryId: this.factoryId,
        deviceType: this.deviceType,
      };
      this.$fetch(api.device.syncDevice, params).then((res) => {
        if (res.success) {
          this.$message.success(res.msgContent);
          // 请求树根节点
          this.getAccessDeviceInfoTree();
          this.devicePage.pageSize = 10;
          this.devicePage.pageNum = 1;
          this.$refs.devTab.reset();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 树的子节点点击事件
    currentChange(data, node) {
      this.showDevList = 1;
      this.treeKey = data.deviceID;
      this.devicePage.pageNum = 1;
      this.devicePage.pageSize = 10;
      this.$refs.devTab.reset();
    },
    getAccessDeviceInfoTree() {
      const params = {
        systemId: this.systemId,
      };
      this.$fetch(api.device.queryPlatSystemDeviceTree, params).then((res) => {
        if (res.success) {
          this.frame = [res.returnObj];
          this.$nextTick(() => {
            this.$refs.refTree.setCurrentKey(this.treeKey);
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 查询部件子设备
    getDevChildrenList() {
      console.log(this.checkIotForm);
      const params = {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.pageNum,
        systemId: this.systemId,
        parentDeviceId: this.checkIotForm.deviceID,
        ...this.searchParams,
      };
      this.$fetch(api.device.queryPlatSystemDeviceListIot, params).then((res) => {
        this.deviceData = res.returnObj.list;
        this.devicePage.total = res.returnObj.total;
      });
    },
    getFireDevList() {
      const param = {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.pageNum,
        systemId: this.systemId,
        ...this.searchParams,
        deviceMarkList: ["27"],
      };
      this.$fetch(api.device.queryFireDevice, param).then((res) => {
        if (res.success && res.returnObj.list) {
          this.deviceData = res.returnObj.list;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 请求部件列表
    getFireDevChildrenList() {
      const params = {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.pageNum,
        systemId: this.systemId,
        parentDeviceId: this.checkIotForm.deviceID,
        ...this.searchParams,
      };
      this.$fetch(api.device.queryFireSubDevice, params).then((res) => {
        if (res.success && res.returnObj.list) {
          this.deviceData = res.returnObj.list;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 根据树查询设备列表
    getDevList() {
      if (this.showDevList == 4) {
        this.getFireDevChildrenList();
        return;
      }
      if (this.showDevList == 3) {
        this.getFireDevList();
        return;
      }
      const params = {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.pageNum,
        systemId: this.systemId,
        parentDeviceId: this.treeKey,
        ...this.searchParams,
      };
      if (this.showDevList == 2) {
        params.parentDeviceId = this.checkIotForm.deviceID;
      }
      this.$fetch(api.device.queryPlatSystemDeviceListIot, params).then((res) => {
        this.deviceData = res.returnObj.list;
        this.devicePage.total = res.returnObj.total;
      });
    },

    // 批量删除设备
    delDev() {
      if (this.selDev.length === 0) {
        this.$message.warning(this.$t("deviceAccess.message.deltips"));
        return;
      }
      this.delConfirm = true;
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.dlgYes();
      });
    },
    // 单独删除设备
    delDevBtn(row) {
      this.selDev = [row.deviceID];
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.dlgYes();
      });
    },
    // 确认删除
    dlgYes() {
      let params = { deviceIDList: this.selDev };
      let url = api.gasTruck.deleteDevice;
      if (this.showDevList == 3) {
        url = api.device.deleteFireDevice;
      } else if (this.showDevList == 4) {
        url = api.device.deletePlatSystemDevice;
      }
      this.$fetch(url, params).then((res) => {
        if (res.success == true) {
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(this.$t("deviceAccess.message.delfail"));
        }
        this.getDevList();
      });
    },

    refresh(row) {
      const params = {
        deviceID: row.deviceID,
      };
      this.$fetch(api.device.queryPlatSystemDeviceDetail, params).then((res) => {
        if (res.success) {
          row.status = res.returnObj.status;
          this.$message.success(res.msgContent);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },

    //查看详情
    seeDel(row) {
      this.dialogVisible = true;
      this.devDetail = JSON.parse(JSON.stringify(row));
      this.devDetail.status = Dic.findByValue("SENU015", row.status);
      this.devDetail.deviceTypeName = Dic.findByValue("SENU086", row.deviceType);

      this.devDetail.deviceMarkName = Dic.findByValue("SENU087", row.deviceMark);
      this.devDetail.subDeviceMarkName = Dic.findByValue("SENU094", row.subDeviceMark);
    },
  },
};
</script>
<style lang="scss" scoped>
.app-panel {
  right: 16px;
}
.vcnDeviceList {
  width: 100%;
  height: 100%;
  .section-main__warp {
    margin: 0 !important;
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.vcnDevicelist_warpd {
  .el-table__fixed-right-patch {
    display: none;
  }
  .section-main__filter {
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 20px 10px;
  }
  .devDetaildata {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
